<template>
  <div>
    <label class="typo__label">{{ label }} <span v-if="isRequired" class="text-danger">*</span></label>
    <multiselect
      :value="value.$model"
      tag-placeholder="เพิ่มในรายการใหม่"
      :placeholder="placeholder"
      label="value"
      track-by="value"
      :options="options"
      :multiple="true"
      :taggable="true"
      @tag="addTag"
      @select="selectValue"
      @remove="removeValue"
      :class="{ 'invalid': isInvalid, 'pass': isPass }"
    ></multiselect>
    <label class="logisty-custom-invalid-feedbace" v-show="isInvalid">โปรดเลือก</label>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  name: 'multi-select-tag-validate',
  props: {
    label: {
      default: null,
      required: true
    },
    value: {
      default: function () {
        return []
      },
      required: true
    },
    options: {
      default: function () {
        return []
      },
      required: false
    },
    placeholder: {
      default: 'ค้นหาหรือเพิ่ม',
      required: false
    },
    isRequired: {
      default: false,
      required: false
    },
    disableNewTag: {
      default: true,
      required: false
    }
  },
  methods: {
    addTag (newTag) {
      if (this.disableNewTag) {
        return
      }

      const tag = {
        value: newTag
      }
      this.options.push(tag)
      this.value.$model.push(tag)
    },
    selectValue (value) {
      this.value.$model.push(value)
    },
    removeValue (removeItem) {
      this.value.$model.splice(this.value.$model.indexOf(removeItem), 1)
    }
  },
  computed: {
    isInvalid () {
      return this.value.$dirty ? this.value.$error : false
    },
    isPass () {
      return !this.value.$error
    }
  }
}
</script>
